import {AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../Authentication/auth.service';

import {DataExchangeService} from '../../../../surface3d/src/lib/API/Public/data-exchange.service';
import {ContainerService} from '../../../../surface3d/src/lib/Utils/container.service';
import {PatientDialogComponent} from './patient-dialog/patient-dialog.component';
import { Sex } from 'projects/surface3d/src/public_api';


@Component({
    selector: 'burncase-model-selection',
    templateUrl: './model-selection.component.html',
    styleUrls: ['./model-selection.component.css']
})
export class ModelSelectionComponent implements OnInit {
    // private _model = new ModelType();

    @ViewChild('img', {static: false}) image: ElementRef<HTMLImageElement>;
    @ViewChild('secondDialog', {static: true}) secondDialog: TemplateRef<any>;

    // defines the min an max range of the weight slider
    public weightMin: number;
    public weightMax: number;
    public weightVal: number;

    // get
    // true -> display "custom" button -> opens shape dialog
    // false only standard models possible
    private _customShape = true;

    // private _imagePath = '../../assets/Human/Images/';

    // TODO: remove containerService
    constructor(private matDialog: MatDialog,
                public containerService: ContainerService,
                private authService: AuthService,
                public dataExchangeService: DataExchangeService
    ) {
        this.weightMin = -0.5;
        this.weightMax = 1.2;
        this.weightVal = 0;
    }

    // public get model() {
    //     this._model.modelHeight = this._dataService.type.modelHeight;
    //     return this._model;
    // }

    public get customShape(): boolean {
        return this._customShape;
    }

    ngOnInit() {
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    /**
     * checks if sex is the sex of the current model
     */
    public isCheckedSex(sex: string): boolean {
        return this.dataExchangeService.patient.model.sex.toString() === sex;
    }


    /**
     * Update the sex of the model
     */
    public sexChanged(sex: string) {
        // only change sex and update model if other sex is selected via button
        if (!this.isCheckedSex(sex)) {
            if (sex && sex !== 'unknown') {
                this.dataExchangeService.patient.model.sex = Sex[sex];
            } else {
                this.dataExchangeService.patient.model.sex = Sex['male'];
            }
            this.updateModel();
        }
    }


    /**
     * logs out the user
     */
    public logout() {
        this.authService.logout();
    }

    /**
     * displays preview of model
     * removes distance markers as models are being changed
     */
    private updateModel() {
        this.dataExchangeService.patient.updateModel();
    }

    // TODO: usage-check
    /**
     * Sets specific weight min and max value if age of model changes.
     * Also sets the value of the weight slider.
     * @param event the id and value of the moved age slider.
     */
    public weightAdjustment(event) {
        // if age slider is moved
        // if (event.id === 2) {
        //     if (this.dataExchangeService.modelAge < 10 && this.dataExchangeService.modelAge > 3) {
        //         if (this.weightMax !== 1) {
        //             this.weightMin = -0.4;
        //             this.weightMax = 1;
        //         }
        //     } else if (this.dataExchangeService.modelAge <= 3) {
        //         if (this.weightMax !== 0.6) {
        //             this.weightMin = -0.3;
        //             this.weightMax = 0.6;
        //         }
        //     } else {
        //         this.weightMin = -0.5;
        //         this.weightMax = 1.2;
        //     }
        //
        //     // get current weight value and set int to min or max weight value if it is not in the allowed range
        //     this.weightVal = this.dataExchangeService.modelWeight;
        //     if (this.weightVal > this.weightMax) {
        //         this.weightVal = this.weightMax;
        //     } else if (this.weightVal < this.weightMin) {
        //         this.weightVal = this.weightMin;
        //     }
        //     this.dataExchangeService.setTargetInfluence(this.weightVal, 6);
        //
        // }
    }

    public openPatientDialog(): void {
        const dialogRef = this.matDialog.open(PatientDialogComponent, {
            width: '20vw',
            data: this.containerService.patient
        });
    }

}
